import { TK } from './translation-keys';

export interface Language {
  code: string;
  translationKey: string;
  abbrTranslationKey: string;
}

export const LANGUAGES: Language[] = [
  {
    code: 'de',
    translationKey: TK.languageSelect.german,
    abbrTranslationKey: TK.languageSelect.germanAbbr,
  },
  {
    code: 'en',
    translationKey: TK.languageSelect.english,
    abbrTranslationKey: TK.languageSelect.englishAbbr,
  },
  {
    code: 'cs',
    translationKey: TK.languageSelect.czech,
    abbrTranslationKey: TK.languageSelect.czechAbbr,
  },
  {
    code: 'fr',
    translationKey: TK.languageSelect.french,
    abbrTranslationKey: TK.languageSelect.frenchAbbr,
  },
  {
    code: 'nl',
    translationKey: TK.languageSelect.dutch,
    abbrTranslationKey: TK.languageSelect.dutchAbbr,
  },
  {
    code: 'sk',
    translationKey: TK.languageSelect.slovakian,
    abbrTranslationKey: TK.languageSelect.slovakianAbbr,
  },
  {
    code: 'lt',
    translationKey: TK.languageSelect.lithuanian,
    abbrTranslationKey: TK.languageSelect.lithuanianAbbr,
  },
];

export function langTranslationKey(code: string): string {
  return LANGUAGES.find((l) => l.code === code)?.translationKey ?? code;
}

export function langAbbrKey(code: string): string {
  return LANGUAGES.find((l) => l.code === code)?.abbrTranslationKey ?? code;
}
